<script setup lang="ts">
defineProps<{ couponCode: string }>();
const { onRemoveCoupon, isDisabled, icon } = useRemoveCoupon();
</script>

<template>
  <button type="button" :disabled="isDisabled" @click="onRemoveCoupon({ code: couponCode })">
    <span class="size-4 text-danger" :class="icon" />
  </button>
</template>
